import Vue from 'vue'

const storage = {
    set(key, value){
        localStorage.setItem(`flyvendas:${key}`, value)
    },

    get(key){
        return localStorage.getItem(`flyvendas:${key}`)
    },

    remove(key){
        localStorage.removeItem(`flyvendas:${key}`)
    },

    exist(key){
        localStorage.getItem(`flyvendas:${key}`) != null
    }
}

const session = {
    set(key, value){
        sessionStorage.setItem(`flyvendas:${key}`, value)
    },

    get(key){
        return sessionStorage.getItem(`flyvendas:${key}`)
    },

    remove(key){
        sessionStorage.removeItem(`flyvendas:${key}`)
    },

    exist(key){
        sessionStorage.getItem(`flyvendas:${key}`) != null
    }
}

Vue.prototype.$storage = storage
Vue.prototype.$session = session

export default storage
export {
    storage,
    session
}
